import {SlctOption} from 'module/Slct/type/SlctType'
import {getSearchRegexString} from 'util/getSearchRegexString'

export function filterOptionsSlct<ModelType extends object | void, ValueType extends string | number>(options: SlctOption<ModelType, ValueType>[], inputValue: string) {
	const regex = getSearchRegexString(inputValue)
	return options.filter(o => {
		return new RegExp(regex, 'gi').test(o.value + '') || new RegExp(regex, 'gi').test(o.label + '')
	})
}

export function filterOptionsSlctNoValue<ModelType extends object | void, ValueType extends string | number>(options: SlctOption<ModelType, ValueType>[], inputValue: string) {
	const regex = getSearchRegexString(inputValue)
	return options.filter(o => {
		return new RegExp(regex, 'gi').test(o.label + '')
	})
}